import { SET_SUBSCRIBE_LOADING, SET_SUBSCRIBE } from '../actions/subscription';
import { LOG_OUT } from '../actions/profile';

const initialData = {
	apiKey: null,
	createdAt: null,
	current: 0,
	isActive: null,
	limit: 0,
	ip: null,
	limitResetAt: null,
	nextResetAt: null,
	loading: false,
	loaded: false,
	state: null,
};

const initialState = { ...initialData };

export default function subscriptionReducer(state = initialState, action) {
	switch (action.type) {
		case SET_SUBSCRIBE_LOADING:
			return { ...state, loading: action.payload };
		case SET_SUBSCRIBE:
			return {
				...state,
				...action.payload,
				loaded: true,
				loading: false,
			};
		case LOG_OUT: {
			return { ...initialData };
		}
		default:
			return state;
	}
}
